<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <transition v-if="style === 'vertical'" name="sidebarLogoFade">
      <div v-if="collapse" key="collapse" class="sidebar-logo-link" to="/dashboard">
        <img v-if="logo" src="@/assets/main_images/logojc.png" class="sidebar-logo" />
        <h1 v-else class="sidebar-title">{{ title }}</h1>
      </div>
      <div v-else key="expand" class="sidebar-logo-link" >
        <div class="big">
          <div class="loginImage">
            <!--<img v-if="logo" :src="logo" class="sidebar-logo" />-->
            <img v-if="logo" src="@/assets/main_images/logojc.png" class="sidebar-logo" />
          </div>
          <h1 class="sidebar-title">中国汽车材料数据系统</h1>
          <h1 class="sidebar-title"></h1>
        </div>
      </div>
    </transition>
    <div v-else class="logo horizontalLogo">
      <img src="@/assets/main_images/logojc.png" alt="">
      <div class="text">
        <div>中国汽车材料数据系统</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "SidebarLogo",
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      style: (state) => state.settings.style,
    })
  },
  data() {
    return {
      title: "Vue Element Admin",
      logo:
        "https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png",
    };
  },
};
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.horizontalLogo {
  position: absolute;
  left: 37px;
  height: 60px;
  display: flex;
  align-items: center;

  img {
    height: 34px;
  }

  .text {
    color: #ffffff;

    border-left: 1px solid #ffffff;
    margin-left: 10px;
    padding-left: 12px;
  }

  .text>div:first-child {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 3px;
  }
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  text-align: center;
  overflow: hidden;

  .big {
    height: 280px;

    .loginImage {
      height: 168px;
      line-height: 168px;
    }
  }

  @media only screen and (max-width: 1366px) {
    .big {
      height: 196px;

      .loginImage {
        height: 118px;
        line-height: 118px;
      }
    }
  }

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 50px;
      height: 50px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 20px;
      font-size: 20px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }

    @media only screen and (max-width: 1366px) {
      & .sidebar-logo {
        width: 60px;
        height: 60px;
      }

      & .sidebar-title {
        line-height: 18px;
        font-size: 18px;
      }
    }

    & .sidebar-title:last-child {
      margin-top: 16px;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
      width: 46px;
      height: 46px;
    }
  }

  @media only screen and (max-width: 1366px) {
    &.collapse {
      .sidebar-logo {
        margin-right: 0px;
        width: 32px;
        height: 32px;
      }
    }
  }
}
</style>
